export const REDUX_PIPELINE_KEYS = {
  UPLOADED_SIZERS: "uploadedSizers",
  EXCEPTIONS: "exceptions",
  OPEN_TASKS: "openTasks",
};
